/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6e2e2d06&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6e2e2d06&lang=stylus&scoped=true"

import exportComponent from "C:\\Users\\RedFlag\\Desktop\\code\\qms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2e2d06"]])

export default __exports__